// geojson
export const PUT_CITIES = "PUT_CITIES"
export const PUT_CONSTITUENCIES = "PUT_CONSTITUENCIES"
export const PUT_STATES = "PUT_STATES"

// results
export const PUT_SEATS = "PUT_SEATS"
export const PUT_TOPLINE = "PUT_TOPLINE"
export const PUT_ERROR = "PUT_ERROR"
export const PUT_LAST_UPDATED = "PUT_LAST_UPDATED"
export const SET_TAB = "SET_TAB"
